import { Button } from 'components/ui';
import React, { useEffect, useState } from 'react'
import { TbCheck, TbPencil } from 'react-icons/tb';

export default function ChatTemplateChatListItem({
  chat,
  isEditing,
  setIsEditing,
  selectedChatId,
  setSelectedChatId,
  getMessages,
  updateChatTitle
}) {

  const [ value, setValue ] = useState(chat?.title?.replaceAll(`"`, ""));

  useEffect(() => {
    if (value != chat?.title?.replaceAll(`"`, "")) {
      updateChatTitle(chat?.id, value);
    }
  }, [isEditing]); 

  return (
    <Button
      variant="plain"
      className={`group relative !px-2 !rounded-lg !py-2 font-normal !h-auto bg-gray-50 dark:bg-gray-900 hover:!bg-gray-100 dark:hover:!bg-gray-800 ${selectedChatId == chat?.id && isEditing != chat?.id && `!bg-gray-200 dark:!bg-gray-700 !font-bold`} ${isEditing == chat?.id && `!bg-gray-100 dark:!bg-gray-800 !border !border-gray-200 dark:!border-gray-700`}`}
      onClick={() => {
        setSelectedChatId(chat?.id);
        getMessages(chat?.id);
      }}
    >
      {isEditing != chat?.id 
        ? <>
          <div className='w-full flex justify-between items-center whitespace-nowrap text-ellipsis overflow-hidden'>
            {value || <i>Untitled</i>}
          </div>
          <div className='absolute hidden group-hover:flex right-0 top-0 px-2 pl-8 bg-gradient-to-r from-transparent via-gray-100 dark:via-gray-800 to-gray-100 dark:to-gray-800 h-full justify-center items-center'>
            <TbPencil 
              className='text-black text-lg hover:opacity-[0.5] transition-all' 
              onClick={(e) => {
                e.stopPropagation();
                setIsEditing(chat?.id)
              }}
            />
          </div>
        </>
        : <div className='flex items-center'>
          <input 
            className='border-0 bg-transparent outline-0 w-full flex-1'
            value={value}
            onChange={(e) => setValue(e.target.value)}
            placeholder='Enter a conversation title'
            onClick={(e) => e.stopPropagation()}         
            onKeyDown={(e) => e.key == 'Enter' && setIsEditing(-1)}    
            autoFocus
          />
          <div className='shrink-0 flex right-0 top-0 px-2 pr-0 h-full justify-center items-center'>
            <TbCheck 
              className='text-green-600 text-lg hover:opacity-[0.5] transition-all' 
              onClick={(e) => {
                e.stopPropagation();
                setIsEditing(-1);
              }}
            />
          </div>
        </div>
      }
    </Button>
  )
}
